module.exports = __webpack_public_path__ + "img/slotmachine_multiplier.42b2d86d.png";